import { render, staticRenderFns } from "./ImportWhite.vue?vue&type=template&id=3bb2ca82&scoped=true&"
import script from "./ImportWhite.vue?vue&type=script&lang=js&"
export * from "./ImportWhite.vue?vue&type=script&lang=js&"
import style0 from "./ImportWhite.vue?vue&type=style&index=0&id=3bb2ca82&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bb2ca82",
  null
  
)

export default component.exports